import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';

@Injectable({
  providedIn: 'root'
})
export class AdminUserService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
  ) { }


  /**
   * Change l'école auquel l'utilisateur est rattaché seulement si c'est un admin
   * Renvoi : {status: error; data : msg error } si non admin sinon {status: success}
   * @param schoolId
   */
  switchSchool(schoolId){
    return this.http.post(this.apiUrl + `switchSchool` , { schoolId } );
  }

  /**
   * Delete un user s'il existe
   * Renvoi : status : success
   * @param userId
   */
  deleteFromCare(userId){
    return this.http.get(`${this.apiUrl}user/deleteFromCare/` + userId) as any;
  }

  /**
   * Update la transaction booking d'un user sur hubspot
   */
  setHubspotDealFromCare(pipelineId, dealId, values?) {
    let datas = null;
    if(values){
      datas = {datas : values};
    }
    return this.http.post(`${this.apiUrl}user/setHubspotDealFromCare/` + pipelineId + '/' + dealId, datas) as any;
  }


  
}
